/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The TokenVerifyBody model module.
 * @module model/TokenVerifyBody
 * @version v0.3
 */
export default class TokenVerifyBody {
  /**
   * Constructs a new <code>TokenVerifyBody</code>.
   * @alias module:model/TokenVerifyBody
   * @class
   * @param dob {Date}
   */
  constructor(dob) {
    this.dob = dob;
  }

  /**
   * Constructs a <code>TokenVerifyBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/TokenVerifyBody} obj Optional instance to populate.
   * @return {module:model/TokenVerifyBody} The populated <code>TokenVerifyBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new TokenVerifyBody();
      if (data.hasOwnProperty('dob'))
        obj.dob = ApiClient.convertToType(data['dob'], 'Date');
      if (data.hasOwnProperty('terms_accepted'))
        obj.termsAccepted = ApiClient.convertToType(data['terms_accepted'], 'Boolean');
    }
    return obj;
  }
}

/**
 * @member {Date} dob
 */
TokenVerifyBody.prototype.dob = undefined;

/**
 * Set to true when the patient accepts the terms.
 * @member {Boolean} termsAccepted
 */
TokenVerifyBody.prototype.termsAccepted = undefined;
